<script>
import { BSkeletonWrapper } from "bootstrap-vue";

export default {
  extends: BSkeletonWrapper
};
</script>